import React from 'react'
import {
  SliderControl,
  useTemplate,
  fonts,
  SelectControl,
  ColorPickerControl,
} from '../../../lib/pdf'
import { useTranslation } from '~/hooks/useTranslation'

const formatDecimal = (value) => {
  if (value >= 1.0) {
    return value.toFixed(2)
  } else {
    return value.toFixed(2).slice(1)
  }
}

const formatInches = (value) => {
  return `${formatDecimal(value)} in`
}

const formatPercent = (value) => {
  return `${Math.round(value * 100)}%`
}

const StyleEditor = () => {
  const { templateSettings, devMode } = useTemplate()
  const { t } = useTranslation('Editor.StyleEditor')

  return (
    <>
      <div className="mb-6 text-lg font-medium text-primary">
        {t('styling')}
      </div>
      <SelectControl title={t('primary_font')} settingName="primaryFontFamily">
        {fonts.map((font) => (
          <option key={font.family} value={font.family}>
            {font.family}
          </option>
        ))}
      </SelectControl>
      <SelectControl title={t('accent_font')} settingName="secondaryFontFamily">
        {fonts.map((font) => (
          <option key={font.family} value={font.family}>
            {font.family}
          </option>
        ))}
      </SelectControl>
      <ColorPickerControl settingName="accentColor" title={t('accent_color')} />
      <SliderControl
        title={t('line_height')}
        min={0.5}
        max={1.5}
        step={0.01}
        settingName="lineHeightMultiplier"
        formattingFunction={formatPercent}
      />

      <div className="mb-6 text-lg font-medium text-primary">
        {t('page_setup')}
      </div>
      <SelectControl title={t('paper_size')} settingName="size">
        <option value="Letter">{t('letter_size')}</option>
        <option value="A4">{t('a4_size')}</option>
      </SelectControl>
      <SliderControl
        title={t('top_and_bottom_margin')}
        min={0.4}
        max={1.5}
        step={0.01}
        settingName="yMargin"
        formattingFunction={formatInches}
      />
      <SliderControl
        title={t('left_and_right_margin')}
        min={0.4}
        max={1.5}
        step={0.01}
        settingName="xMargin"
        formattingFunction={formatInches}
      />
      {devMode && <pre>{JSON.stringify(templateSettings, null, 2)}</pre>}
    </>
  )
}

export default StyleEditor
